export default __webpack_public_path__ + "media/images/front/about/hero_sm-22d74b48a9e4fe37295d011c28743388.jpg";